import React from 'react'

import Button from '@material-ui/core/Button'
import classes from './Button.scss'

const button = ({
  color,
  variant,
  btnColor,
  className,
  style,
  btnClass,
  overrideClass,
  size,
  fullWidth,
  clicked,
  disabled,
  children,
  startIcon,
  endIcon,
  type
}) => {
  let buttonClass = [classes.Button]

  switch (btnColor) {
    case 'primary':
      buttonClass = [classes.Button, classes.Primary]
      break
    case 'secondary':
      buttonClass = [classes.Button, classes.Secondary]
      break
    case 'success':
      buttonClass = [classes.Button, classes.Success]
      break
    case 'warning':
      buttonClass = [classes.Button, classes.Warning]
      break
    case 'danger':
      buttonClass = [classes.Button, classes.Danger]
      break
    case 'info':
      buttonClass = [classes.Button, classes.Info]
      break
    case 'darken':
      buttonClass = [classes.Button, classes.Darken]
      break
    case 'light':
      buttonClass = [classes.Button, classes.Light]
      break
    case 'transparant':
      buttonClass = [classes.Button, classes.Transparant]
      break
    default:
      break
  }

  if (btnClass && overrideClass) {
    buttonClass = btnClass
  } else if (btnClass) {
    let classes = [btnClass]
    if (typeof btnClass === 'object') {
      classes = [...btnClass]
    }
    buttonClass = [...buttonClass, ...classes]
  }
  if (variant === 'noVariant') {
    variant = null
  }
  if (!variant) {
    variant = 'contained'
  }
  return (
    <Button
      type={type}
      style={style}
      className={className || buttonClass.join(' ')}
      variant={variant}
      color={color}
      size={size}
      onClick={clicked}
      disabled={disabled}
      fullWidth={fullWidth || false}
      startIcon={startIcon}
      endIcon={endIcon}>
      {children}
    </Button>
  )
}

export default button
